module.exports = __webpack_public_path__ + "static/img/img_requirements.1786686659715.png";